import * as ControllerInterfaces from '../Interfaces/ControllerInterfacesBarrel';
// Import the abstract controller factory.
import AbstractControllerFactory from './AbstractControllerFactory';
// Import the implemented mock controllers.
import * as MockControllers from '../Mock/MockControllersBarrel';

export default class MockControllerFactory extends AbstractControllerFactory {

	public constructor() {
        super();
    }

    public getAppLinkController(): ControllerInterfaces.IAppLinkController {
        return new MockControllers.MockAppLinkController();
    }

    public getAuthenticationController(): ControllerInterfaces.IAuthenticationController {
        throw new MockControllers.MockAuthenticationController();
    }

    public getClaimsController(): ControllerInterfaces.IClaimsController {
        return new MockControllers.MockClaimsController();
    }

    public getDocumentController(): ControllerInterfaces.IDocumentController {
        return new MockControllers.MockDocumentController();
    }

    public getEligibilityMessagePriorityController(): ControllerInterfaces.IEligibilityMessagePriorityController {
        return new MockControllers.MockEligibilityMessagePriorityController();
    }
    
    public getEndorsementController(): ControllerInterfaces.IEndorsementController {
        return new MockControllers.MockEndorsementController();
    }

    public getEndorsementMortgageeController(): ControllerInterfaces.IEndorsementMortgageeController {
        return new MockControllers.MockEndorsementMortgageeController();
    }

	public getEndorsementPolicyEntityController(): ControllerInterfaces.IEndorsementPolicyEntityController {
		return new MockControllers.MockEndorsementPolicyEntityController();
	}

	public getEndorsementValidationController(): ControllerInterfaces.IEndorsementValidationController {
		return new MockControllers.MockEndorsementValidationController();
	}   

    public getIdentityController(): ControllerInterfaces.IIdentityController {
        return new MockControllers.MockIdentityController();
    }

    public getMinCostPerSquareFootController(): ControllerInterfaces.IMinCostPerSquareFootController {
        return new MockControllers.MockMinCostPerSquareFootController();
    }

    public getMinCostPerSquareFootLookupController(): ControllerInterfaces.IMinCostPerSquareFootLookupController {
        return new MockControllers.MockMinCostPerSquareFootLookupController();
    }

    public getMinCostPerSquareFootVersionController(): ControllerInterfaces.IMinCostPerSquareFootVersionController {
        return new MockControllers.MockMinCostPerSquareFootVersionController();
    }

    public getNewBusinessApplicationController(): ControllerInterfaces.INewBusinessApplicationController {
        return new MockControllers.MockNewBusinessApplicationController();
    }

    public getPolicyController(): ControllerInterfaces.IPolicyController {
        return new MockControllers.MockPolicyController();
    }

    public getPolicyNoteController(): ControllerInterfaces.IPolicyNoteController {
        return new MockControllers.MockPolicyNoteController();
    }

    public getProductController(): ControllerInterfaces.IProductController {
        return new MockControllers.MockProductController();
    }

    public getPropertyController(): ControllerInterfaces.IPropertyController {
        return new MockControllers.MockPropertyController();
    }

    public getRolesController(): ControllerInterfaces.IRolesController {
        return new MockControllers.MockRolesController();
    }

    public getSignupController(): ControllerInterfaces.ISignUpController {
        return new MockControllers.MockSignUpController();
    }
}